import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'carm-breadcrumb-view',
  templateUrl: './breadcrumb-view.component.html',
  styleUrls: ['./breadcrumb-view.component.scss'],
})
export class BreadcrumbViewComponent implements OnInit {

  @Input() levels: { link: string, name: string, dataCy: string }[];
  @Input() lastLoggedOut: Date;

  constructor() { }

  ngOnInit() {
  }

}
